import { render, staticRenderFns } from "./ItemGoods.vue?vue&type=template&id=6db90344&scoped=true&"
import script from "./ItemGoods.vue?vue&type=script&lang=js&"
export * from "./ItemGoods.vue?vue&type=script&lang=js&"
import style0 from "../style.css?vue&type=style&index=0&id=6db90344&prod&scoped=true&lang=css&"
import style1 from "./ItemGoods.vue?vue&type=style&index=1&id=6db90344&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db90344",
  null
  
)

export default component.exports